var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "IForm",
      staticStyle: { padding: "0 10px 10px 10px" },
      attrs: {
        inline: true,
        model: _vm.formData,
        rules: _vm.rules,
        size: _vm.pageSize
      }
    },
    [
      _c("div", { staticClass: "rootBox", style: _vm.styles }, [
        _c("div", { staticClass: "leftBox" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBaseInfo,
                  expression: "showBaseInfo"
                }
              ],
              staticClass: "headerBox"
            },
            [
              _c(
                "div",
                { staticClass: "header-user-info" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "院校", prop: "deptName" } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.formData.deptName, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入..." },
                        model: {
                          value: _vm.formData.name,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "账号", prop: "userName" } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.formData.userName, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份", prop: "userTypeStr" } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.formData.userTypeStr, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.organizeList && _vm.organizeList.length
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "组织", prop: "firstStructId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                placeholder: "请选择组织"
                              },
                              model: {
                                value: _vm.formData.firstStructId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "firstStructId", $$v)
                                },
                                expression: "formData.firstStructId"
                              }
                            },
                            _vm._l(_vm.organizeList, function(item) {
                              return _c("el-option", {
                                key: item.structId,
                                attrs: {
                                  label: item.structName,
                                  value: item.structId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: "组织", prop: "firstStructName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.formData.firstStructName,
                              disabled: ""
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "headerBg",
                  staticClass: "headerBg",
                  style: _vm.getHeadBackground(),
                  on: { click: _vm.selectImage }
                },
                [
                  _c("input", {
                    ref: "sectionImg",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: ".png, .jpg, .jpeg" },
                    on: {
                      change: function($event) {
                        return _vm.headerBgChange($event)
                      }
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mainBox" },
            [
              _vm.roleList && _vm.roleList.length
                ? _c(
                    "el-form-item",
                    { attrs: { label: "角色", prop: "roleIdList" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            placeholder: "请选择角色",
                            multiple: "",
                            filterable: ""
                          },
                          model: {
                            value: _vm.formData.roleIdList,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "roleIdList", $$v)
                            },
                            expression: "formData.roleIdList"
                          }
                        },
                        _vm._l(_vm.roleList, function(item) {
                          return _c("el-option", {
                            key: item.roleId,
                            attrs: { label: item.roleName, value: item.roleId }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "性别", prop: "sex" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.formData.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "sex", $$v)
                        },
                        expression: "formData.sex"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "男", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "女", value: 1 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "出生年月", prop: "birthdayDate" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "picker-options": _vm.birthdayPicker
                    },
                    model: {
                      value: _vm.formData.birthdayDate,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "birthdayDate", $$v)
                      },
                      expression: "formData.birthdayDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "证件类型", prop: "cardType" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.formData.cardType,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "cardType", $$v)
                        },
                        expression: "formData.cardType"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "身份证", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "其他", value: 1 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "证件号", prop: "idCard" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.idCard,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "idCard", $$v)
                      },
                      expression: "formData.idCard"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.email,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "微信", prop: "weChat" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.weChat,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "weChat", $$v)
                      },
                      expression: "formData.weChat"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "QQ", prop: "penguin" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    on: {
                      input: function($event) {
                        return _vm.toInteger(_vm.formData, "penguin")
                      }
                    },
                    model: {
                      value: _vm.formData.penguin,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "penguin", $$v)
                      },
                      expression: "formData.penguin"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "省份", prop: "provinceId" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.formData.provinceId,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "provinceId", $$v)
                        },
                        expression: "formData.provinceId"
                      }
                    },
                    _vm._l(_vm.provinces, function(item) {
                      return _c("el-option", {
                        key: item.id + item.name,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "通讯地址", prop: "postalAddress" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.postalAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "postalAddress", $$v)
                      },
                      expression: "formData.postalAddress"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "工作单位", prop: "workPlace" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.workPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workPlace", $$v)
                      },
                      expression: "formData.workPlace"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "部门", prop: "department" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.department,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "department", $$v)
                      },
                      expression: "formData.department"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "专业方向", prop: "majorField" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.majorField,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "majorField", $$v)
                      },
                      expression: "formData.majorField"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "职称", prop: "professionalTitle" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.professionalTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "professionalTitle", $$v)
                      },
                      expression: "formData.professionalTitle"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "职位", prop: "position" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.position,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "position", $$v)
                      },
                      expression: "formData.position"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "银行卡号", prop: "bankAccount" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    on: {
                      input: function($event) {
                        return _vm.toInteger(_vm.formData, "bankAccount")
                      }
                    },
                    model: {
                      value: _vm.formData.bankAccount,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "bankAccount", $$v)
                      },
                      expression: "formData.bankAccount"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "开户行", prop: "bankDeposit" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入..." },
                    model: {
                      value: _vm.formData.bankDeposit,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "bankDeposit", $$v)
                      },
                      expression: "formData.bankDeposit"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rightBox" },
          _vm._l(_vm.achievements, function(item) {
            return _c(
              "div",
              {
                key: item.key,
                staticClass: "addBox",
                style: _vm.getAddBackground(item),
                on: {
                  click: function($event) {
                    return _vm.editInfo(item)
                  }
                }
              },
              [
                _c("el-form-item", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  attrs: { prop: item.key }
                })
              ],
              1
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.currentItem.title,
            visible: _vm.dialogVisible,
            width: "50%",
            "before-close": _vm.handleClose,
            modal: _vm.dialogModal,
            "close-on-click-modal": false,
            "lock-scroll": false,
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("wjl-editor", {
            attrs: {
              "only-key": _vm.onlyKey,
              maxHeight: "400px",
              height: "400px"
            },
            model: {
              value: _vm.formData[_vm.currentItem.key],
              callback: function($$v) {
                _vm.$set(_vm.formData, _vm.currentItem.key, $$v)
              },
              expression: "formData[currentItem.key]"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.ok } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02e585fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02e585fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_educa_module/educa/components/teacherInfo.vue
// module id = null
// module chunks = 